import { Stack } from '@mantine/core'
import { AnyRouter, createFileRoute } from '@tanstack/react-router'
import WorkChart from 'components/work/WorkChart'
import WorkTable from 'components/work/WorkTable'
import { usersQuery } from 'hooks/users'
import { Account } from 'types/auth'
import { WorkType } from 'types/work'

export const Route = createFileRoute('/_auth/_admin/analytics/cutting')({
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(usersQuery)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const users = Route.useLoaderData<AnyRouter, Array<Account>>()

  return (
    <Stack gap="xl">
      <WorkChart workType={WorkType.CUTTING} users={users} />
      <WorkTable workType={WorkType.CUTTING} users={users} />
    </Stack>
  )
}
